import { FC, useMemo } from "react";

import { CreateGUFWellFunctionTask, EditGUFWellFunctionTask } from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { getFormObjectValues, initializeFormEditingState } from "@/helpers/helpers";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";
import { GufWellFunctionFormProps } from "@/types/form-types";

import { validateGufWellFunctionForm } from "../schema/guf-validation";
import { getGufWellFunctionSchema } from "../schema/guf-well-function-schema";
import { useGufWellFunctionUiSchema } from "../schema/guf-well-function-ui-schema";

const GufWellFunctionForm: FC<GufWellFunctionFormProps> = (props) => {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();

  const { oldUploadTask, task, type } = getFormObjectValues(props);
  const { isEditing, getIsEditing } = initializeFormEditingState(props);

  const { formData, handleChange } = useBrostarFormDataStorage<
    CreateGUFWellFunctionTask | EditGUFWellFunctionTask
  >({
    key: "guf-well-function",
    task,
  });

  const uiSchema = useGufWellFunctionUiSchema(formData?.metadata.qualityRegime);

  const schema = useMemo(() => getGufWellFunctionSchema({ type, isEditing }), [type, isEditing]);

  const onSubmit = async () => {
    if (!formData) return;
    if (getIsEditing(formData)) {
      await api.editGUFWellFunction(formData);
    } else {
      await api.createGUFWellFunction(formData);
    }
    if (oldUploadTask?.uuid) api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <BrostarForm<CreateGUFWellFunctionTask | EditGUFWellFunctionTask>
      uploadTask={oldUploadTask}
      schema={schema}
      formData={formData}
      onChange={handleChange}
      uiSchema={uiSchema}
      onSubmit={onSubmit}
      customValidate={validateGufWellFunctionForm}
    />
  );
};

export { GufWellFunctionForm };
